var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.companies.length > 0)?_c('add-companies-group-component',{attrs:{"companies-group-data-prop":null}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }